// Will be replaced during production builds - see prepare.sh
export const BuildVersion = "main-gha.18735";
